import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=3ed3d4d2&scoped=true&"
import script from "./RadioList.vue?vue&type=script&lang=js&"
export * from "./RadioList.vue?vue&type=script&lang=js&"
import style0 from "./RadioList.vue?vue&type=style&index=0&id=3ed3d4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3d4d2",
  null
  
)

export default component.exports